import { Table } from "antd";
import styles from "../styles.module.scss";
import { inventoryColumns, inventoryData } from "./utils";

interface InvetoryTableProps {}

const InvetoryTable: React.FC<InvetoryTableProps> = () => {
  return (
    <Table
      columns={inventoryColumns}
      dataSource={inventoryData}
      pagination={{ pageSize: 10 }}
      rowKey="key"
      scroll={{ x: 100 }}
      className={styles.table}
      summary={(pageData) => {
        const totals = {
          availableFBA: 0,
          receivingFBA: 0,
          available3PL: 0,
          inTransit: 0,
          allAvailable: 0,
          sales30: 0,
          doi: 0,
          poUnitsForecast: 0,
        };

        pageData.forEach((r) => {
          totals.availableFBA += r.availableFBA;
          totals.receivingFBA += r.receivingFBA;
          totals.available3PL += r.available3PL;
          totals.inTransit += r.inTransit;
          totals.allAvailable += r.allAvailable;
          totals.sales30 += r.sales30;
          totals.doi += r.doi;
          totals.poUnitsForecast += r.poUnitsForecast;
        });

        return (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
            <Table.Summary.Cell index={1} />
            <Table.Summary.Cell index={2} align="right">
              {totals.availableFBA.toLocaleString()}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={3} align="right">
              {totals.receivingFBA.toLocaleString()}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={4} align="right">
              {totals.available3PL.toLocaleString()}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={5} align="right">
              {totals.inTransit.toLocaleString()}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={6} align="right">
              {totals.allAvailable.toLocaleString()}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={7} align="right">
              {totals.sales30.toLocaleString()}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={8} align="right">
              {totals.doi.toLocaleString()}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={9} align="right">
              {totals.poUnitsForecast.toLocaleString()}
            </Table.Summary.Cell>
          </Table.Summary.Row>
        );
      }}
    />
  );
};

export default InvetoryTable;
